'use strict';

const { encrypt, decrypt } = require('./src/core');

module.exports = {
	encrypt,
	decrypt
}